import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Store } from "@ngxs/store";
import { AuthSessionFacade } from "@services/auth-session/auth-session.facade";
import { UserState } from "@store/user/user.state";

export const authGuard: CanActivateFn = (_route) => {
  const store = inject(Store);
  const router = inject(Router);
  const authSessionFacade = inject(AuthSessionFacade);

  const isLoggedIn = store.selectSnapshot(UserState.isLoggedIn);

  if (isLoggedIn || authSessionFacade.hasSession()) {
    return true;
  }

  return router.createUrlTree(["/login"]);
};
